export async function initializeHtmlCss() {
    return {
        runHtmlCss: (html, css) => runHtmlCss(html, css),
    };
}

export async function runHtmlCss(html, css) {

    try {
        if (html.includes('<script>')) {
            return 'Script tags are not allowed.';
        }

        return `
            <!DOCTYPE html>
            <html>
                <head>
                    <style>${css}</style>
                </head>
                <body>
                    ${html}
                </body>
            </html>
        `;
    } catch (error) {
        return error.message;
    }
}